let _ = require('../_.js');
let $ = jQuery;

let _after_sign_in_callback;

let reveal_email_option_timeout = null;

_.AuctionUI_Signup = class AuctionUI_Signup {

    static init() {

        // Hook register button
        _.on_ui_update_once(".ac-btn-action-register", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Modal.hide();
                _.AuctionUI_Signup.signup_modal();
            });
        });

        _.on_ui_update_once('.phone_number', function () {
            $(this).phoneInput();
        });

        _.on_ui_update_once(".ac-btn-action-back-to-sign-in", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Modal.hide();
                _.AuctionUI_Login.login_modal();
            });
        });
    }

    // Displays the signup modal.
    // Optionally provide a callback for what should happen after successful sign in.
    static async signup_modal(callback_on_success = null) {

        $("#chatbox").hide();

        _._login_modal_callback_on_success = callback_on_success;

        let form_selector = "#auctioncast-signup-form";
        let $form = $(form_selector);

        console.log("Attempted");
        $("#ac-modal-signup").modal_show();

        // return;
        _.reset_form_errors($form);
        _.reset_form_values($form);

        // Populate states
        $('#auctioncast-signup-form-state').empty();
        for (let i in _.states) {
            let option = $('<option value="' + i + '">' + _.states[i] + '</option>');
            if (i == "MN") {
                option.attr("selected", "selected");
            }
            $('#auctioncast-signup-form-state').append(option);
        }

        // Remove read only on email and password, this prevents browser from trying to autocomplete
        setTimeout(function () {

            // Prefill email if user is a backend user
            let backend_user = _.AuctionUI_Session.get_backend_user();
            if (backend_user && backend_user.email) {
                $("#signup-form-email").val(backend_user.email);
                $("#auctioncast-signup-form-first_name").val(backend_user.first_name);
                $("#auctioncast-signup-form-last_name").val(backend_user.last_name);
                const char_set = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                const random_string = Array.from({ length: 16 }, () => char_set.charAt(Math.floor(Math.random() * char_set.length))).join('');
                $("#signup-form-email").attr("readonly", true);
                $("#signup-form-password").attr("readonly", true);
                $('#signup-form-password').val(random_string);
                $("#signup-form-password_confirmation").attr("readonly", true);
                $("#signup-form-password_confirmation").val(random_string);
                // Focus on next field since email is prefilled
                $("#signup-form-first-name").focus();
            }
        }, 1000);

        // Submit button

        $("#auctioncast-signup-form-submit").click(async function (e) {
            e.preventDefault();

            let signup_form_values = _.serialize_form($form);

            _.reset_form_errors($form);

            try {
                let signup_response = await _.backend_ajax('session', 'signup', signup_form_values, $form);

                await _.Modal.hide();

                // Pin number verification
                _.AuctionUI_Signup.signup_verify_modal(signup_form_values, signup_response);

            } catch (error) {
                console.log(error);
                _.apply_form_errors($form, error);
            }
        });
    }

    // Displays the signup pin number verification modal..
    static async signup_verify_modal(signup_form_values, signup_response) {

        let data = signup_form_values;

        data.phone_verification_code = null;
        data.phone_number_to_verify = signup_response.registrant.phone_number_to_verify;

        let form_selector = "#ac-modal-signup-verify-form";
        let $form = $(form_selector);

        $("#ac-modal-signup-verify").modal_show();

        $("#ac-modal-signup-verify-form-emailoption").hide();
        clearTimeout(reveal_email_option_timeout);
        reveal_email_option_timeout = setTimeout(function () {
            $("#ac-modal-signup-verify-form-emailoption").show();
        }, 45000);

        $("#ac-modal-signup-verify-form-phone-prompt").show();
        $("#ac-modal-signup-verify-form-email-prompt").hide();
        $("#ac-modal-signup-verify-form-emailoption").show();

        $(".ac-modal-signup-verify-thephone").text(_.formatPhoneNumber(signup_response.registrant.phone_number_to_verify));

        if (signup_response.situation == 'existing') {
            $("#ac-modal-signup-verify-already-exists").show();
        } else {
            $("#ac-modal-signup-verify-already-exists").hide();
        }

        _.reset_form_errors($form);
        _.reset_form_values($form);

        $(".ac-modal-signup-first-digit").focus();

        // Pressing enter key submits form
        $(form_selector).off('keyup').keyup(function (event) {
            if (event.keyCode === 13) {
                $(this).submit();
            }
        });

        // Verify via email handler
        $("#verify-via-email").off('click').click(async function (e) {
            e.preventDefault();
            _.Modal.hide();
            data.web_session_activity_token = _.Web_Session.get_session_cookie();
            let fallback_response;
            try {
                fallback_response = await _.backend_ajax('session', 'signup_email_fallback', data, $form);
            } catch (error) {
                // Refused (no email on file, too many codes): back to the text message prompt with the reason
                $("#ac-modal-signup-verify").modal_show();
                _.apply_form_errors($form, error);
                return;
            }
            await _.sleep(1000);
            _.reset_form_values($form);
            $("#ac-modal-signup-verify-form-phone-prompt").hide();
            $("#ac-modal-signup-verify-form-email-prompt").show();
            $("#ac-modal-signup-verify-form-emailoption").hide();
            $("#ac-modal-signup-verify").modal_show();
            // Masked address the server sent the code to: the one on file, which may not be the one typed
            $(".ac-modal-signup-verify-theemail").text(fallback_response.email_destination);
            $(".ac-modal-signup-first-digit").focus();
        });

        // Submit handler
        $(form_selector).off('submit').submit(function (e) {
            e.preventDefault();

            (async function () {

                _.reset_form_errors($form);

                data.web_session_activity_token = _.Web_Session.get_session_cookie();

                try {
                    data.phone_verification_code = $form.find('.thedigits').val();

                    let verify_response = await _.backend_ajax('session', 'signup_verify', data, $form);

                    _.AuctionUI_Session.set_token_cookie(verify_response.token);

                    await _.Modal.unclosable("Successful", $("<span style='font-weight: bold; font-size: 18px' />").html("Your account has been created and you are signed in.<br /><br />Please wait..."));

                    await _.AuctionUI_Session.refresh();

                    await _.sleep(2000);

                    await _.Modal.hide();

                    // Refresh chat messages now that there might be private messages.
                    // Maybe move to a on_login event dispatch sort of pattern later.
                    _.AuctionUI_Chat.refresh_chat();

                    // Execute success callback if it was set earlier
                    if (_._login_modal_callback_on_success) {
                        _._login_modal_callback_on_success();
                        _._login_modal_callback_on_success = null;
                    }

                    // On non-auction pages, reload the page to update the header/UI with logged-in state
                    if (!_.ac_state.auction || !_.ac_state.auction.id) {
                        console.log("Reloading page after signup (non-auction page)");
                        location.reload();
                    }


                } catch (error) {
                    _.apply_form_errors($form, error);
                    _.reset_form_values($form);
                    $(".ac-modal-signup-first-digit").focus();
                }
            }())

        });
    }

}

